// Interpolated, never written inside a `tq` template: the trademark must not be translated, and the
// translation pipeline leaves `{{placeholders}}` untouched.
export const WHATSAPP = 'WhatsApp';
